<template>
  <div class="asc-role-grid">
    <asc-ag-grid-filter
      :key="`asc-analytic-grid_${gridId}`"
      :grid-options="agGridOptions"
      :column-defs="getGridColumnDefs"
      :row-data="agGridRowData"
    ></asc-ag-grid-filter>
    <div v-if="!agGridRowData.length" class="asc-role--no-data">
      <asc-accent-button
        button-text="Add a role"
        :on-click="handleAddRole"
        :outline="true"
        :secondary="true"
        :block="true"
      ></asc-accent-button>
      <p>You currently have no roles created.</p>
    </div>
  </div>
</template>

<script>
import {
  AscAgGridFilter,
  AscAgGridAutocompleteFloatFilter,
  AscTooltipCellRenderer,
} from '@/components/agGrid'
import { getFilterOptions } from '@/components/agGrid/AgGridOptions'
import { AscGridPropsMixin, AscGridMethodsMixin } from '@/components/mixins'
import AscAccentButton from '@/components/atoms/AscAccentButton'

export default {
  name: 'AscRoleGrid',
  components: {
    AscAgGridFilter,
    AscAgGridAutocompleteFloatFilter,
    AscTooltipCellRenderer,
    AscAccentButton,
  },
  mixins: [AscGridPropsMixin, AscGridMethodsMixin],

  props: {
    values: {
      type: Array,
      default: () => [],
    },
    onOpen: {
      type: Function,
      default: () => {},
    },
    addRole: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      agGridOptions: getFilterOptions(this, {
        defaultColDef: {
          tooltipComponent: 'AscTooltipCellRenderer',
        },
        rowSelection: 'single',
        onGridReady: this.handleGridReady,
        onFirstDataRendered: this.handleFirstDataRendered,
        onGridSizeChanged: this.handleGridSizeChanged,
        onCellClicked: this.handleCellClicked,
      }),
    }
  },

  computed: {
    mappedValues() {
      return this.values
    },
    agGridRowData() {
      return this.mappedValues
    },
    getGridColumnDefs() {
      return [
        {
          headerName: 'Name',
          field: 'name',
          filter: 'agTextColumnFilter',
        },

        {
          headerName: 'Description',
          field: 'description',
          filter: 'agTextColumnFilter',
        },
      ]
    },
  },
  methods: {
    handleCellClicked(event) {
      this.onOpen(event.data)
    },
    handleAddRole() {
      this.addRole()
    },
  },
}
</script>

<style lang="scss">
.asc-role-grid {
  .asc-role--no-data {
    display: flex;
    flex-direction: column;
    p {
      margin: auto;
      margin-top: 10px;
      text-align: center;
      font-size: 14px;
    }
  }
}
</style>
